<script lang="ts">
    import type { NavButton } from './Segments.types';

    interface Props {
        segment: NavButton | undefined;
        paginate: (offset: number) => void;
    }

    let { segment, paginate }: Props = $props();

    const navButtons = {
        previous: {
            title: 'zurück',
            symbol: '<',
        },
        next: {
            title: 'weiter',
            symbol: '>',
        },
    };
    const pageLinkButton = $derived(segment ? navButtons[segment.type] : undefined);
</script>

{#if segment && pageLinkButton}
    <li
        class="reptile-segment-nav-button__item"
        data-qa="reptile-paging-{segment.type}"
        data-testid="reptile-segment-nav-button--{segment.type}"
    >
        <button
            class={['reptile-segment-nav-button__button', 'reptile-segment-nav-button__button--neighbour']}
            onclick={() => paginate(segment.offset)}
        >
            <span title={pageLinkButton.title}>{pageLinkButton.symbol}</span>
        </button>
    </li>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/colors';

    .reptile-segment-nav-button {
        &__item {
            float: left;
            min-width: 30px;
            font-weight: normal;
            text-align: center;
        }

        &__button {
            cursor: pointer;

            display: block;

            box-sizing: border-box;
            width: 100%;
            min-height: 30px;
            margin-top: 0;
            margin-bottom: 0;
            padding: 5px tokens.$oc-base-dimension-16;
            border: medium none;
            border-radius: 3px;

            font-family: var(--oc-base-font-otto-sans), sans-serif;
            font-size: 0.75rem;
            font-weight: 400;
            line-height: 1.5em;
            text-align: center;
            text-decoration: none;

            background-clip: padding-box;
            outline: 0 none;

            -webkit-tap-highlight-color: rgb(0 0 0 / 0%);

            &--neighbour {
                font-family: OttoIcons, Arial, Helvetica, sans-serif !important;
                color: colors.$reptile-color-white;
                background: colors.$reptile-color-red-dark;

                & span {
                    font-size: 1.25em;
                    font-style: normal !important;
                }
            }
        }
    }
</style>
